import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { DocumentText, Add } from '@/components/icons';
import ReportListItem from '@/components/reports/ReportListItem';
import { EmptyState } from '@/components/system';
import { Button } from '@/components/ui/button';
import Loading from '@/components/ui/Loading';
import { ReportPage } from '@/pages/constants';
import { createPageUrl } from '@/utils';
import { containerVariants } from '../animations';
import { ReportsListProps } from '../types';
import DashboardAsTable from './DashboardAsTable';
import DashboardMobileReportCard from './DashboardMobileReportCard';

export const DashboardReportList = ({
    reports,
    isLoading,
    viewMode,
    onDelete,
    onExport,
}: ReportsListProps) => {
    if (isLoading) return <Loading />;

    if (reports.length === 0) {
        return (
            <div className="p-4 sm:p-6">
                <EmptyState
                    icon={DocumentText}
                    title="Nenhum laudo encontrado"
                    description="Tente ajustar sua busca ou filtros para localizar um laudo existente."
                    action={
                        <Link to={createPageUrl(ReportPage)}>
                            <Button>
                                <Add className="size-4" />
                                Criar seu primeiro laudo
                            </Button>
                        </Link>
                    }
                />
            </div>
        );
    }

    return (
        <div className="p-4 sm:p-6">
            <motion.div
                className="grid grid-cols-1 gap-3 md:hidden"
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                {reports.map((report) => (
                    <DashboardMobileReportCard
                        key={report.id}
                        report={report}
                        onDelete={(id) => onDelete(id)}
                        onExport={(id) => onExport(id)}
                    />
                ))}
            </motion.div>

            <div className="hidden md:block">
                {viewMode === 'grid' ? (
                    <motion.div
                        className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3"
                        variants={containerVariants}
                        initial="hidden"
                        animate="visible"
                    >
                        {reports.map((report) => (
                            <ReportListItem
                                key={report.id}
                                report={report}
                                onDelete={() => onDelete(report.id)}
                                onExport={() => onExport(report.id)}
                                viewMode={viewMode}
                            />
                        ))}
                    </motion.div>
                ) : (
                    <DashboardAsTable
                        onDelete={(id) => onDelete(id)}
                        onExport={(id) => onExport(id)}
                        reports={reports}
                    />
                )}
            </div>
        </div>
    );
};
